$(function () {
  const path = location.pathname.split("/").pop();
  const currentHash = location.hash.slice(1);

  if (path === "tnc.html") {
    if (currentHash) {
      $(".tnc-container__content > div").removeClass("active");
      const selectedContent = $(`.tnc-container__content .tnc-container__${currentHash}`);
      selectedContent.addClass("active");
    }
  }
});

$(".tnc-container .tnc-container__tab p").on("click", function () {
  location.hash = $(this).attr("data-hash");

  $(".tnc-container__content > div").removeClass("active");
  const selectedContent = $(`.tnc-container__content .tnc-container__${$(this).attr("data-hash")}`);
  selectedContent.addClass("active");

  $(this).siblings("p").removeClass("active");
  $(this).addClass("active");
});
